import React from 'react';
import { Link } from 'react-router';
import Button from '@ordermentum/ui-shared/atoms/Button';
import { connect } from 'react-redux';
import { UserFlags } from '@ordermentum/ui-types';
import { Location } from '@ordermentum/ui-definitions';
import { BackgroundWithOverlay } from '../Background';
import {
  Card,
  EntityImage,
  EntityImageContainer,
  ButtonText,
  ZIndexContainer,
  ButtonContainer,
} from './App.style';
import { RootState } from '../../redux/store';

type EntityType = 'retailer' | 'supplier';
type Props = {
  location: Location;
  flags: UserFlags;
  loggedIn: boolean;
};
type State = {
  hoveredCard: EntityType | '';
};

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hoveredCard: '',
    };
  }

  onMouseEnter = (type: EntityType) => () => {
    this.setState({ hoveredCard: type });
  };

  onMouseLeave = () => {
    this.setState({ hoveredCard: '' });
  };

  render() {
    const isLoggedIn = !this.props.loggedIn;
    return (
      <BackgroundWithOverlay>
        <Card>
          <EntityImageContainer>
            <Link
              to={{
                pathname: isLoggedIn
                  ? '/sign-up/supplier'
                  : '/register/supplier',
                query: this.props.location.query,
              }}
            >
              <EntityImage entityType="supplier">
                <ButtonContainer
                  otherHovered={
                    this.state.hoveredCard === '' ||
                    this.state.hoveredCard === 'retailer'
                  }
                  onMouseEnter={this.onMouseEnter('supplier')}
                  onMouseLeave={this.onMouseLeave}
                >
                  <ZIndexContainer>
                    <Link
                      to={{
                        pathname: isLoggedIn
                          ? '/sign-up/supplier'
                          : '/register/supplier',
                        query: this.props.location.query,
                      }}
                    >
                      <Button type="primary">
                        <ButtonText>I&apos;M A SUPPLIER</ButtonText>
                      </Button>
                    </Link>
                  </ZIndexContainer>
                </ButtonContainer>
              </EntityImage>
            </Link>
            <Link
              to={{
                pathname: isLoggedIn
                  ? '/sign-up/retailer'
                  : '/register/retailer',
                query: this.props.location.query,
              }}
            >
              <EntityImage entityType="retailer">
                <ButtonContainer
                  otherHovered={
                    this.state.hoveredCard === '' ||
                    this.state.hoveredCard === 'supplier'
                  }
                  onMouseEnter={this.onMouseEnter('retailer')}
                  onMouseLeave={this.onMouseLeave}
                >
                  <ZIndexContainer>
                    <Link
                      to={{
                        pathname: isLoggedIn
                          ? '/sign-up/retailer'
                          : '/register/retailer',
                        query: this.props.location.query,
                      }}
                    >
                      <Button type="primary">
                        <ButtonText>I&apos;M A RETAILER</ButtonText>
                      </Button>
                    </Link>
                  </ZIndexContainer>
                </ButtonContainer>
              </EntityImage>
            </Link>
          </EntityImageContainer>
        </Card>
      </BackgroundWithOverlay>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  flags: state?.flags?.data ?? {},
  loggedIn: !!state?.profile?.data?.id,
});

export default connect(mapStateToProps)(App);
